"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setScene = exports.getScene = void 0;
var _scene;
function getScene() {
    return _scene;
}
exports.getScene = getScene;
function setScene(scene) {
    _scene = scene;
}
exports.setScene = setScene;
//# sourceMappingURL=scene.js.map